import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const initialState = {
    isWidgetShown: false,
    isItemAddedToCart: false,
    isFasletAnalyticTriggered: false,
    fasletShoppingId: '',
    orderTrackingData: {
        orderNumber: '',
        paymentStatus: '',
        cartEntries: [],
    },
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.setItemAddedToCart, (state, { payload }) => ({
        ...state,
        isItemAddedToCart: payload,
    }))
        .addCase(actions.setIsWidgetShown, (state, { payload }) => ({
        ...state,
        isWidgetShown: payload,
    }))
        .addCase(actions.setFasletShoppingId, (state, { payload }) => ({
        ...state,
        fasletShoppingId: payload,
    }))
        .addCase(actions.setFasletOrderTrackingData, (state, { payload }) => ({
        ...state,
        orderTrackingData: payload,
    }))
        .addCase(actions.setInitialOrderTrackingData, (state) => ({
        ...state,
        orderTrackingData: {
            ...initialState.orderTrackingData,
        },
    }))
        .addCase(actions.setFasletAnalyticTrigger, (state, { payload }) => ({
        ...state,
        isFasletAnalyticTriggered: payload,
    }));
});
